import type { WorkflowOperationType } from '../constants';
import type { RuleUpdateErrorType, RuleUpdateOperationType } from '../update/constants';
import type {
  BooleanRuleArray,
  RuleObject,
  Rules,
  Threshold,
} from './schema';

// ================ UI ================
export const elementTypes = {
  action: 'action',
  actionoption: 'actionoption',
  dataroute: 'dataroute',
  group: 'group',
  snapshot: 'snapshot',
  threshold: 'threshold',
} as const;

export type ElementType = keyof typeof elementTypes;

export type NodeEditorTab = 'rule' | 'dependents' | 'datarouting' | 'options' | 'configuration';

export enum LineRuleTypes {
  THRESHOLD = 'threshold',
  RULE_GROUP = 'ruleGroup',
}

export type LineRule = {
  path: string;
  value: RuleObject | BooleanRuleArray | string; // if string, that means threshold public id
  type: LineRuleTypes;
};

export enum OperationMessageType {
  action = 'action',
  actionRuleThreshold = 'actionRuleThreshold',
  actionExpression = 'actionExpression',
  undo = 'undo',
}

export type WorkflowOperationMessage = {
  id: string;
  publicId?: string;
  type: OperationMessageType;
  timestamp: number;
  message: WorkflowOperationType | RuleUpdateOperationType | RuleUpdateErrorType;
  data?: any; // this is intentional because we actually don't know at this point what are these going to be. later we may scope it out.
};

export type WorkflowFailureHandlingMode = 'full-threshold' | 'best-effort';

export enum RuleBuilderSubEditorType {
  ISOLATED_EDITOR = 'isolatedEditor',
  MLA_EDITOR = 'mlaEditor',
  AGGREGATIONS_EDITOR = 'aggregationsEditor',
}

export enum RuleBuilderSubEditorSide {
  LHS = 'lhs',
  RHS = 'rhs',
}

// item located at the specified path. Currently used for expressions only
export type PendingParenthesisRelativeLocation = 'before' | 'after';

// only used within the expression editor
export interface PendingParenthesisInfo {
  path: string | null;
  // behavior defaults to 'after' when not defined
  side?: PendingParenthesisRelativeLocation;
}

// ================ Engine ================
export type EngineValidationObject = {
  publicId: string;
  type: string;
  manualResolution?: boolean;
  data: {
    [key: string]: unknown;
  } | Rules[] | Threshold;
};

export type EngineValidationData = {
  actions: EngineValidationObject[];
  thresholds?: EngineValidationObject[];
};


// ================ Transformations ================
export type TransformIssue = {
  type?: string;
  data?: Record<string, unknown>;
};

export type ObjectIdTransformationMap = {
  [key: string]: string;
};

export type ObjectIdReverseTransformationMap = {
  [key: string]: number;
};
